import React from 'react';
import ChartSelectCondition from '../chart-line-components/ChartLine';

interface Props {}

const ChartNothing: React.FC<Props> = () => {
  return (
    <div>
      <ChartSelectCondition />
    </div>
  );
};

export default ChartNothing;
